(function($){
  'use strict';

  if(!$.gnv){
      $.gnv = new Object();
  };

  $.gnv.enableTransformOnScroll =  function (){
    if($('[data-transformOnScroll]').length)
      $('[data-transformOnScroll]').gnv_transformOnScroll();
  };

  $.gnv.transformOnScroll = function(el, options){
    var base = this;

    base.$el = $(el);
    base.el = el;

    base.$elTop = $(el).offset().top;

    base.$el.data("gnv.transformOnScroll", base);

    base.init = function(){
      base.options = $.extend({},$.gnv.transformOnScroll.defaultOptions, options);

      base.initDataOptions();

      base.$el.css('transform','translate(0,-'+base.options.offset_y_start+'px)');

      $(window).on('scroll touchmove', function(){
        base.run();
      });

      $(window).on('resize', function(){
        base.$elTop = $(el).offset().top;
        base.run();
      });

    };

    base.initDataOptions = function(){
      var data = base.$el.data();
      if(data.transformonscrollOffsetstart)
        base.options.offset_start = data.transformonscrollOffsetstart;

      if(data.transformonscrollOffsetend)
        base.options.offset_end = data.transformonscrollOffsetend;

      if(data.transformonscrollOffsetstartmobile)
        base.options.offset_start_mobile = data.transformonscrollOffsetstartmobile;

      if(data.transformonscrollOffsetendmobile)
        base.options.offset_end_mobile = data.transformonscrollOffsetendmobile;

      if(data.transformonscrollOffsetystart)
        base.options.offset_y_start = data.transformonscrollOffsetystart;

      if(data.transformonscrollOffsetyend)
        base.options.offset_y_end = data.transformonscrollOffsetyend;
    }

    base.run = function(){
      var top = $(window).scrollTop(),
          upperbound = base.$elTop - base.options.offset_start,
          lowerbound = base.$elTop - base.options.offset_end;

      if ($(window).width() < 768){
        upperbound = base.$elTop - base.options.offset_start_mobile,
        lowerbound = base.$elTop - base.options.offset_end_mobile;
      }

      if (top >= upperbound && top < lowerbound) {
        var x = -(top-upperbound)*100/(upperbound-lowerbound),
            y = base.options.offset_y_start-(base.options.offset_y_start/100*x);

        base.$el.css('transform','translate(0,'+y+'px)');
      }
    }

    base.init();
  };

  $.gnv.transformOnScroll.defaultOptions = {
    offset_start: 500,
    offset_end: 0,
    offset_start_mobile: 500,
    offset_end_mobile: 0,
    offset_y_start: 100,
    offset_y_end: 0
  };

  $.fn.gnv_transformOnScroll = function(options){
    return this.each(function(){
      (new $.gnv.transformOnScroll(this, options));
    });
  };

  $.gnv.enableTransformOnScroll();

})(jQuery);




